import React from 'react';
import { Select } from 'antd';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Status from './../../../../TopQualities/status.jsx';
import style from './style.module.scss';

const { Option } = Select;

const SelectInput = ({
  name,
  label,
  placeholder,
  isRequired = false,
  options = [],
  ...restProps
}) => {
  return (
    <Field name={name}>
      {({ field, form }) => {
        const value = form.values[name];
        const touched = form.touched[name];
        const error = form.errors[name];
        const showError = touched && (!value || error);

        return (
          <div className={style['input-wrapper']}>
            {label && (
              <p className={style.label}>
                <span>{label}</span>
                {isRequired && <Status isFilled={!showError && !!value} />}
              </p>
            )}

            <div className={style.box}>
              <Select
                id={name}
                value={value}
                placeholder={placeholder}
                className={style.input}
                status={showError ? 'error' : ''}
                style={{
                  width: '100%',
                  height: '40px',
                }}
                dropdownStyle={{
                  fontSize: '14px',
                }}
                dropdownAlign={{ points: ['tl', 'bl'] }}
                onChange={(val) => form.setFieldValue(name, val)}
                onBlur={() => form.setFieldTouched(name, true)}
                {...restProps}>
                {options.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>

            {isRequired && showError && <p className={style.error}>{error || `${label} is required`}</p>}
          </div>
        );
      }}
    </Field>
  );
};

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
};

export default SelectInput;
